import { IRightsContext } from "./IRightsContext";

/**
 * Rozhraní uchovávající aktuální a předchozí kontext, vzhledem ke kterému se vyhodnocují práva
 */
export interface IRightsContexts {
    /**
     * Aktuální kontext
     */
    context: IRightsContext;

    /**
    * Předchozí kontext
    */
    previousContext: IRightsContext;
}
